import { useState } from 'react';
import { Eye, Type, Sun, Moon, Minus, Plus, RotateCcw } from 'lucide-react';

export function AccessibilityMenu() {
  const [isOpen, setIsOpen] = useState(false);
  const [fontSize, setFontSize] = useState(100);
  const [contrast, setContrast] = useState('default');

  const increaseFontSize = () => {
    if (fontSize < 150) {
      const newSize = fontSize + 10;
      setFontSize(newSize);
      document.documentElement.style.setProperty('--font-scale', `${newSize}%`);
    }
  };

  const decreaseFontSize = () => {
    if (fontSize > 90) {
      const newSize = fontSize - 10;
      setFontSize(newSize);
      document.documentElement.style.setProperty('--font-scale', `${newSize}%`);
    }
  };

  const toggleContrast = () => {
    const newContrast = contrast === 'default' ? 'high' : 'default';
    setContrast(newContrast);
    document.documentElement.setAttribute('data-contrast', newContrast);
  };

  const resetSettings = () => {
    setFontSize(100);
    setContrast('default');
    document.documentElement.style.setProperty('--font-scale', '100%');
    document.documentElement.setAttribute('data-contrast', 'default');
  };

  return (
    <div className="fixed bottom-24 right-8 z-50">
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="bg-blue-600 text-white p-3 rounded-full shadow-lg hover:bg-blue-700 transition-colors"
        aria-label="Accessibility Options"
      >
        <Eye className="h-6 w-6" />
      </button>

      {isOpen && (
        <div className="absolute bottom-full right-0 mb-4 bg-white rounded-lg shadow-xl p-4 w-64">
          <h2 className="text-lg font-semibold text-gray-900 mb-4 flex items-center">
            <Type className="h-5 w-5 mr-2" />
            Accessibility Options
          </h2>

          <div className="space-y-4">
            <div>
              <h3 className="text-sm font-medium text-gray-700 mb-2">Text Size</h3>
              <div className="flex items-center justify-between">
                <button
                  onClick={decreaseFontSize}
                  className="p-2 text-gray-600 hover:text-blue-600 transition-colors"
                  aria-label="Decrease Font Size"
                  disabled={fontSize <= 90}
                >
                  <Minus className="h-5 w-5" />
                </button>
                <span className="text-gray-600">{fontSize}%</span>
                <button
                  onClick={increaseFontSize}
                  className="p-2 text-gray-600 hover:text-blue-600 transition-colors"
                  aria-label="Increase Font Size"
                  disabled={fontSize >= 150}
                >
                  <Plus className="h-5 w-5" />
                </button>
              </div>
            </div>

            <div>
              <h3 className="text-sm font-medium text-gray-700 mb-2">Contrast</h3>
              <button
                onClick={toggleContrast}
                className="w-full flex items-center justify-center gap-2 px-4 py-2 border rounded-md hover:bg-gray-50"
              >
                {contrast === 'default' ? (
                  <>
                    <Moon className="h-5 w-5" />
                    High Contrast
                  </>
                ) : (
                  <>
                    <Sun className="h-5 w-5" />
                    Normal Contrast
                  </>
                )}
              </button>
            </div>

            <div className="pt-2 border-t">
              <button
                onClick={resetSettings}
                className="w-full flex items-center justify-center gap-2 px-4 py-2 text-gray-600 hover:text-blue-600"
              >
                <RotateCcw className="h-5 w-5" />
                Reset Settings
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}